import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
// import ServiceData2 from "../../data/service/ServiceMain2.json";
import ServiceData from "../../data/service/ServiceMain.json";
import { slugify } from "../../utils";

const AllData = ServiceData;
// const AllData = ServiceData2;

const ServicePropOne1 = ({ colSize, serviceStyle, itemShow, marginTop }) => {
  const { slug } = useParams();
  // console.log(slug,"ll");
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileOrTablet(window.innerWidth < 1023); // tablet and below
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function formatSlug(slug) {
    return slug
      ?.replace(/-/g, " ") // Replace hyphens with spaces
      ?.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
  }

  const ifmServices = "ifm-services"; // Define the variable

  const formattedSlug = formatSlug(slug);
  //   console.log(formattedSlug, "format slug"); // Outputs: "Security Services"

  // Find the service whose slug matches the current slug
  const matchingService = ServiceData.find(
    (service) => service?.title === formattedSlug
  );

  //   console.log(matchingService.process?.steps?.map((item)=> item.title), "Matching Service");
  // console.log(matchingService, "123");
  const topMargin = (index) => {
    if (marginTop === "yes") {
      if (index === 0) {
        return "mt--200 mt_md--0";
      } else if (index === 1) {
        return "mt--100 mt_md--0";
      } else {
        return "mt--0";
      }
    } else {
      return "";
    }
  };

  return (
    <>
      {matchingService &&
        matchingService.process?.steps.slice(0, itemShow).map((data, index) => (
          <div
            className={`${colSize} ${topMargin(index)}`}
            style={{ paddingTop: "15px", paddingBottom: "15px" }}
            key={index}
          >
            <div className={`services-grid ${serviceStyle}`}
             style={{ marginBottom: isMobileOrTablet ? "0" : "30px" }}
            >
              <div className="thumbnail">
                <img src={process.env.PUBLIC_URL + data.thumb} alt="icon" />
              </div>
              <div className="content">
                <h5 className="title">
                  <Link
                    to={
                      process.env.PUBLIC_URL +
                      (slug === ifmServices
                        ? `/service/${slugify(data.title)}`
                        : `/service/${slugify(matchingService.title)}/${slugify(
                            data.title
                          )}`)
                    }
                  >
                    {data.title}
                  </Link>
                </h5>
                <p style={{margin: isMobileOrTablet ? "0 0 15px 0" : "0 0 40px 0"}} dangerouslySetInnerHTML={{ __html: data.paragraph }}></p>
                <Link
                  to={
                    process.env.PUBLIC_URL +
                    (slug === ifmServices
                      ? `/service/${slugify(data.title)}`
                      : `/service/${slugify(matchingService.title)}/${slugify(
                          data.title
                        )}`)
                  }
                  className="more-btn"
                  style={{paddingBottom: isMobileOrTablet ? "0" : "40px"}}
                >
                  Find out more {isMobileOrTablet ? "→" : ""}
                </Link>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export default ServicePropOne1;
